export default () => ({
  items: {}
})
